import { PropsWithChildren, useRef, useState } from 'react';

import {
  NewDateFilter,
  CheckboxFilter,
  Pill,
} from '@hapvida/hapvida-core-components';

import newUseFilterParams from '@hapvida/hapvida-core-components/src/hooks/newUseFilterParams';
import { FilterKeys } from '@hapvida/hapvida-core-components/src/components/NewFilterSummary/constants';

import { CompanyFilterItem } from 'hooks/useCompany/components/CompanyFilterItem';
import useCompaniesRelatedList from 'hooks/services/companies/relatedList';
import { statuses } from '@flows/private/movements/constants/common';
import { MOVEMENT_STATUS_COLOR, MOVEMENT_STATUS_NAME } from '@constants';

import type {
  FiltersDrawerButtonProps,
  IFilterOptions,
  TFilterValue,
} from '../types';
import { FilterDrawerBase } from '../FilterDrawerBase';
import { formatObjectToFilterUrl } from '../FilterDrawerBase/utils/formatObjectToFilterUrl';

export function NewFilterDrawerMovements({
  subtitle,
  title,
  ...buttonProps
}: PropsWithChildren<FiltersDrawerButtonProps>) {
  const [visibleDrawer, setVisibleDrawer] = useState(false);
  const { changeMultiple } = newUseFilterParams({});
  const { listRelatedCompanies } = useCompaniesRelatedList();

  const handleToggleDrawer = () => {
    setVisibleDrawer(!visibleDrawer);
  };

  const dateRangeRef = useRef<{ filterValue: TFilterValue } | null>(null);

  const refs: IFilterOptions = {
    status: useRef(null),
    organizationalGroup: useRef(null),
  };

  const handleApplyAll = () => {
    const rangeDateValueRef: TFilterValue =
      (dateRangeRef?.current && dateRangeRef?.current.filterValue) ?? {};
    let inputsValueObj: TFilterValue = {};

    Object.keys(refs).forEach(key => {
      const ref = refs[key];

      if (ref?.current) {
        inputsValueObj = { ...inputsValueObj, ...ref.current?.filterValue };
      }
    });

    const objectFilterValues = { ...inputsValueObj, ...rangeDateValueRef };

    changeMultiple(formatObjectToFilterUrl(objectFilterValues));
    handleToggleDrawer();
  };
  const handleOrganizationalGroup =
    listRelatedCompanies?.data?.pages?.map(company => ({
      content: <CompanyFilterItem company={company} />,
      label: company?.name?.trade || company?.name?.legal,
      value: company?.id,
    })) ?? [];

  const onStatus = () =>
    statuses.map(({ value, label }) => ({
      label,
      value,
      content: (
        <Pill
          text={MOVEMENT_STATUS_NAME[value] ?? '-'}
          color={MOVEMENT_STATUS_COLOR[value]}
        />
      ),
    }));

  return (
    <FilterDrawerBase
      title={title}
      subtitle={subtitle}
      handleApplyAll={handleApplyAll}
      {...buttonProps}
    >
      <CheckboxFilter
        filters={onStatus()}
        title="Status das movimentações"
        name="status"
        ref={refs.status}
      />

      <CheckboxFilter
        filters={handleOrganizationalGroup}
        title="Empresas"
        name="organizational-group"
        searchFieldProps={{
          placeholder: 'Empresa, CNPJ ou contrato',
        }}
        loadNextPage={listRelatedCompanies}
        ref={refs.organizationalGroup}
      />

      <NewDateFilter
        startDateName={FilterKeys.START_DATE}
        endDateName={FilterKeys.END_DATE}
        ref={dateRangeRef}
      />
    </FilterDrawerBase>
  );
}
